(function () {
  function ready() {
    var toggle = document.querySelector('[data-cnc-menu-toggle]');
    var menu = document.querySelector('[data-cnc-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.documentElement.classList.toggle('cnc-menu-open', !open);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();

(function () {
  function updateCartCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i += 1) nodes[i].textContent = count;
  }

  function enhanceQuickAdd() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('[data-cnc-quick-add]');
      if (!form || !window.fetch || !window.FormData) return;

      event.preventDefault();
      var button = form.querySelector('[data-cnc-add-button]');
      var label = form.querySelector('[data-cnc-add-label]');
      var originalLabel = label ? label.textContent : 'Add to cart';

      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }
      if (label) label.textContent = 'Adding…';

      fetch(form.action + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
          return response.json();
        })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (button) {
            button.classList.remove('is-loading');
            button.classList.add('is-added');
          }
          if (label) label.textContent = 'Added';
          window.setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.classList.remove('is-added');
            }
            if (label) label.textContent = originalLabel;
          }, 1600);
        })
        .catch(function (error) {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
          if (label) label.textContent = originalLabel;
          window.alert(error.message || 'Unable to add this item.');
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceQuickAdd);
  else enhanceQuickAdd();
})();
